import { render, staticRenderFns } from "./JobStatistics.vue?vue&type=template&id=d51ccbe6&lang=pug&"
import script from "./JobStatistics.vue?vue&type=script&lang=ts&"
export * from "./JobStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports